module.exports = __webpack_public_path__ + "img/homeimg05@2x_wps.78560e89.png";